import React from 'react';
import CompetitionReport from '../../../pages/CompetitionReport';

export const graderRoutes = [
  { path: '/competition-report', element: <CompetitionReport /> }
];
